import gsap from 'gsap';
import { useRef } from "react"

export default function useImageLoad() {
  const imageRef = useRef(null);
  const onLoad = () => {
    if (imageRef.current) {
      const mm = gsap.matchMedia();

      mm.add({
        hasMotion: "(prefers-reduced-motion: no-preference)",
        hasNoMotion: "(prefers-reduced-motion: reduce)",
      },
      (context) => {
        const { hasMotion } = context.conditions;

        gsap.to(imageRef.current, {
          opacity: 1,
          duration: hasMotion ? 0.2 : 0
        })
      })
    }
  }
  return {
    imageRef, onLoad
  }
}